import { clearInputField, getQueryStringParameter } from '../../../helpers.js'

$(document).ready(() => {
  const $form = $('form#natural-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'investment_goals') {
    return;
  }

  const $investmentGoals = $('#investmentGoals input[type=radio]', $form);

  $investmentGoals.on('click', (inputElement) => {
    $form.submit();
  });
})
